import { InvoiceHeader } from "../invoices/invoice-header";
import { PortalOrder } from "../order-creation/portal-order";
import { OrderHeader } from "../orders/order-header";
import { CategorySum } from "./category-sum";

export class GraphData {

    public GetGraphDataForInvoices(invoices: InvoiceHeader[]) {
        if (!invoices || invoices.length == 0) {
            return [];
        }

        const categorizedHeaders = this.createCategoryEntriesInvoice(invoices);
        return this.CreateCategories(categorizedHeaders);
    }

    public GetGraphDataForOrders(orders: OrderHeader[]): CategorySum[] {
        if (!orders || orders.length == 0) {
            return [];
        }

        const categorizedHeaders = this.createCategoryEntriesOrder(orders);
        return this.CreateCategories(categorizedHeaders);
    }

    public GetGraphDataForNewOrders(orders: PortalOrder[]): CategorySum[] {
        if (!orders || orders.length == 0) {
            return [];
        }

        const categorizedHeaders = this.createCategoryEntriesNewOrder(orders);
        return this.CreateCategories(categorizedHeaders);
    }


    private CreateCategories(categorizedHeaders: headerEntry[]) {
        if (!categorizedHeaders) {
            return [];
        }

        let categories: CategorySum[] = [];
        categorizedHeaders.forEach(catHeader => {
            let summary = categories.find(x => x.category == catHeader.categoryName);
            if (summary && catHeader.id) {
                summary.headerIds.push(catHeader.id);
                if (catHeader.value) {
                    summary.sum += catHeader.value;
                }
            }
            else {
                summary = {
                    category: catHeader.categoryName,
                    sum: catHeader.value,
                    headerIds: [catHeader.id]
                };
                categories.push(summary);
            }
        });
        categories = categories.sort((a, b) => {
            const aMonth = +a.category.split('/')[0];
            const bMonth = +b.category.split('/')[0];
            return aMonth > bMonth ? 1 : -1;
        });
        return categories;
    }

    private createCategoryEntriesInvoice(invoices: InvoiceHeader[]): headerEntry[] {
        if (!invoices) {
            return [];
        }
        return invoices.map(x => {
            let category = "other";
            if (x.InvoiceDate) {
                const invoiceDate = new Date(x.InvoiceDate);
                if (!isNaN(invoiceDate.getTime())) {
                    category = (invoiceDate.getMonth() + 1).toString() + '/' + invoiceDate.getFullYear().toString();
                }
            }
            const TotalAmount = x.TotalAmount;
            const orderHeader = x;

            return {
                categoryName: category,
                value: TotalAmount,
                id: orderHeader.Id
            } as headerEntry;
        });
    }

    private createCategoryEntriesOrder(orders: OrderHeader[]): headerEntry[] {
        if (!orders) {
            return [];
        }
        return orders.map(x => {
            let category = "other";
            if (x.OrderCreationTime) {
                const bkOrderDateKey = new Date(x.OrderCreationTime);
                if (!isNaN(bkOrderDateKey.getTime())) {
                    category = (bkOrderDateKey.getMonth() + 1).toString() + '/' + bkOrderDateKey.getFullYear().toString();
                }
            }
            const totalNetAmount = x.TotalAmount;
            const orderHeader = x;
            return {
                categoryName: category,
                value: totalNetAmount,
                id: orderHeader.Id
            } as headerEntry;
        });
    }
    private createCategoryEntriesNewOrder(orders: PortalOrder[]): headerEntry[] {
        if (!orders) {
            return [];
        }
        return orders.map(x => {
            let category = "other";
            if (x.requestedDeliveryDate) {
                const requestedDeliveryDate = new Date(x.requestedDeliveryDate);
                if (!isNaN(requestedDeliveryDate.getTime())) {
                    category = (requestedDeliveryDate.getMonth() + 1).toString() + '/' + requestedDeliveryDate.getFullYear().toString();
                }
            }
            const totalNetAmount = x.totalValue;
            const orderHeader = x;
            return {
                categoryName: category,
                value: totalNetAmount,
                id: orderHeader.id
            } as headerEntry;
        });
    }
}


interface headerEntry {
    categoryName: string,
    id: string;
    value: number,
}
